export default {
  btn_add_attachment: "Add <span class='text-info'>{entity}</span> Attachment",
  btn_add_comment_to_issue: "Add a comment to this Issue...",
  btn_add_comment_to_work: "Add a comment to this Work...",
  btn_add_comment_to_work_order: "Add a comment to this Work Order...",
  btn_add_identifier: "Add Identifier",
  btn_add_to_work_order: "Add to Work Order",
  btn_change_work_order: "Change Work Order",
  btn_apply: "Apply",
  btn_apply_changes: "Apply changes",
  btn_argh: "Argh!",
  btn_associate_location: "Associate Location",
  btn_association_change: "Change association",
  btn_cancel: "Cancel",
  btn_change_password: "Change password",
  btn_close: "Close",
  btn_close_it: "Close it!",
  btn_close_work_order: "Close Work Order",
  btn_confirm: "Confirm",
  btn_connect: "Connect",
  btn_continue: "Continue",
  btn_correct_issue: "Correct Issue!",
  btn_create_item: "Create Item",
  btn_create_work_order: "Create Work Order",
  btn_delete: "Delete",
  btn_delete_selected: "Delete selected",
  btn_disassociate: "Disassociate",
  btn_discard_changes: "Discard changes",
  btn_done: "Done",
  btn_dont_show: "Don’t show this again",
  btn_download_attachments: "Download selected Attachments",
  btn_easter_egg: "What a lot of things!",
  btn_go_to_item: "Go to Item",
  btn_go_back: "Go Back",
  btn_go_home: "Go Home",
  btn_got_it: "Got it!",
  btn_got_it_period: "Got it.",
  btn_hide_section: "Hide section",
  btn_lets_go: "Let's go already!",
  btn_load_default: "Load default",
  btn_load_selected: "Load selected",
  btn_log_me_out: "Blast it! Log me out",
  btn_noted: "Noted!",
  btn_ok: "OK",
  btn_open_identify: "Open Identify",
  btn_open_issue: "Open Issue",
  btn_open_work_orders: "Open Work Order",
  btn_overwrite_selected: "Overwrite selected",
  btn_perform: "Perform Ad-Hoc Corrective Work",
  btn_perform_correction: "Perform Correction!",
  btn_perform_planned: "Perform Planned Corrective Work",
  btn_perform_work: "Perform Work!",
  btn_proceed: "That's okay, proceed!",
  btn_proof_of_presence: "Proof of presence",
  btn_raise: "Raise",
  btn_raise_issue: "Raise issue",
  btn_raise_next_issue: "Raise next issue",
  btn_refresh_workspaces: "Refresh Workspaces",
  btn_reject_it: "Reject it!",
  btn_reject: "Reject Work",
  btn_reject_corrective_work: "Reject Corrective Work",
  btn_accept: "Accept Work",
  btn_accept_corrective_work: "Accept Corrective Work",
  btn_reload_app: "Reload app",
  btn_remove: "Remove",
  btn_remove_attachments: "Remove selected Attachments",
  btn_request_removal: "Request Removal",
  btn_reset: "Reset",
  btn_reset_selection: "Reset selection",
  btn_resume: "Resume Work",
  btn_retry: "Retry",
  btn_review_work: "Review Work",
  btn_save: "Save",
  btn_save_changes: "Save changes",
  btn_save_selection: "Save selection",
  btn_search_attachments: "Search Attachments",
  btn_see_all: "See all",
  btn_see_all_count: "See all ({count})",
  btn_see_performed_work: "See Performed Work",
  btn_select_all: "Select all",
  btn_select_none: "Select none",
  btn_select_issues: "Select Issues",
  btn_select_items: "Select Items",
  btn_selected: "{count} selected",
  btn_send: "Send",
  btn_sign_out: "Sign out",
  btn_submit: "Submit",
  btn_submit_changes: "Submit changes",
  btn_supersede: "Supersede!",
  btn_take_photo: "Take photo",
  btn_to_issues: "To Issues",
  btn_to_raised_issues: "Back to Raised Issues",
  btn_to_work_orders: "To Work Orders",
  btn_try_again: "Try Again",
  btn_understood: "Understood!",
  btn_understood_without_exclamation: "Understood",
  btn_undo: "Undo",
  btn_unlock_key: "Change Unlock Key",
  btn_upload_new_file: "Upload new file",
}
